import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

const getOrder = async (orderId) => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/order/" + orderId,
    { headers: AuthHeader.authHeader() });
  console.log("ORDER RESPONSE", response);
  return response.data;
};

const submitOrder = async (orderId, paymentType) => {
  console.log("IN SUBMIT CART");
  try {
    const response = await axios.post(process.env.REACT_APP_API_URL + "/submitorder",
      {
        "orderId": orderId,
        "paymentType": paymentType
      },
      { headers: AuthHeader.authHeader() });
    console.log("ORDER RESPONSE", response);
    return response.data;
  } catch (error) {
    console.log("SUBMIT ORDER ERROR", error.response.data.error);
    if (error.response && error.response.data && error.response.data.error) {
      if (error.response.data.error === "NOT_ENOUGH_FUNDS") {
        return { error: "error", message: "Your balance is less than the order total. Please refesh the page and pay the remainder of your balance with a credit card." };

      } else {
        return { error: "error", message: error.response.data.error };

      }
    } else {
      return { error: "error", message: "An error occurred while submitting your order. Please try again" };
    }
  }
};

const submitDemoOrder = async (orderId) => {
  console.log("IN SUBMIT DEMO ORDER");
  try {
    const response = await axios.post(process.env.REACT_APP_API_URL + "/submitdemoorder",
      {
        "orderId": orderId
      },
      { headers: AuthHeader.authHeader() });
    console.log("DEMO ORDER RESPONSE", response);
    return response.data;
  } catch (error) {
    console.log("SUBMIT DEMO ORDER ERROR", error);
    if (error.response && error.response.data && error.response.data.message) {
      return { error: "error", message: error.response.data.message };
    } else {
      return { error: "error", message: "An error occurred while submitting your demo order. Please try again" };
    }
  }
};

const getOpenOrders = async () => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/orders/open",
    { headers: AuthHeader.authHeader() });
  return response.data;
};

const updateBillingAddress = async (billingAddressId) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/order/updateAddress",
    { billingAddressId: billingAddressId },
    { headers: AuthHeader.authHeader() });
  return response.data;
}

const orderNewHireKit = async (items, address, polybagChecked, polybagLabel, kitId) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/order/newhirekit",
    {
      items: items,
      address: address,
      polybag: polybagChecked,
      polybagLabel: polybagLabel,
      kitId: kitId
    },
    { headers: AuthHeader.authHeader() });
  return response.data;
};

const orderNewHireKitSelf = async (items, address, polybagChecked, polybagLabel, kitId) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/order/newhirekit",
    {
      items: items,
      address: address,
      polybag: polybagChecked,
      polybagLabel: polybagLabel,
      kitId: kitId
    },
    { headers: AuthHeader.authHeader() });
  return response.data;
};

const addKitToCart = async (items, order) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/addkittoorder",
    {
      items: items,
      order: order
    },
    { headers: AuthHeader.authHeader() });
  return response.data;
};

const getAllOrders = async (filter) => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/allorders?range=[" + filter[1] + "," + filter[2] + "]&filter=" + filter[0], { headers: AuthHeader.authHeader() });
  console.log("GET ALL RESPONES", response);
  return { data: response.data, count: response.headers["total-items"] };
};

const getSuperAdminOrders = async (filter, page, perPage, search) => {
  let url = process.env.REACT_APP_API_URL + "/admin/super/orders?range=[" + page + "," + perPage + "]&filter=" + filter;
  if (search && search.trim() !== '') {
    url += "&search=" + encodeURIComponent(search);
  }
  const response = await axios.get(url, { headers: AuthHeader.authHeader() });
  console.log("GET SUPER ADMIN ORDERS RESPONSE", response);
  return { data: response.data, count: response.headers["total-items"] };
};

const OrderService = {
  getOrder,
  submitOrder,
  submitDemoOrder,
  getOpenOrders,
  updateBillingAddress,
  orderNewHireKit,
  orderNewHireKitSelf,
  addKitToCart,
  getAllOrders,
  getSuperAdminOrders
};
export default OrderService;